/* eslint-disable max-len */
export const BankIntegration = { url: "/api/bank-integration/%7Baction%7D", type: undefined as { action: string | number; } };
